import { render, staticRenderFns } from "./LoadExpenses.vue?vue&type=template&id=7201246c"
import script from "./LoadExpenses.vue?vue&type=script&lang=js"
export * from "./LoadExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports